import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=01bc3bde"
import script from "./Simple.vue?vue&type=script&lang=js"
export * from "./Simple.vue?vue&type=script&lang=js"
import style0 from "./Simple.vue?vue&type=style&index=0&id=01bc3bde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports